angular.module('picmonicng').directive('hybridSref', [
  'BrowseService',
  '$state',
  function (BrowseService, $state) {
    return {
      restrict: 'A',
      scope: {
        params: '=hybridSrefParams',
      },
      link: function (scope, element, attrs) {
        if (attrs.hybridSref && attrs.hybridSref !== 'false') {
          element.bind('click', function () {
            scope.$apply(function () {
              if (BrowseService.browseOpen) {
                BrowseService.go(attrs.hybridSref, scope.params ? scope.params : {});
              } else {
                $state.go(attrs.hybridSref, scope.params ? scope.params : {}).catch(function (e) {
                  if (attrs.hybridSref.indexOf('app.pathways') === 0) {
                    var parts = attrs.hybridSref.split('.');
                    parts[0] = '';
                    parts[2] = scope.params.market;
                    if (parts[4]) {
                      parts[4] = scope.params.pathway_id;
                    }
                    if (scope.params.curriculum && parts[3]) {
                      parts.splice(4, 0, [scope.params.curriculum]);
                    }
                    window.location = parts.join('/');
                  }
                });
              }
            });
          });
        }
      },
    };
  },
]);
